import { render, staticRenderFns } from "./ProblemStatus.vue?vue&type=template&id=a09d34a2&scoped=true&"
import script from "./ProblemStatus.vue?vue&type=script&lang=js&"
export * from "./ProblemStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProblemStatus.vue?vue&type=style&index=0&id=a09d34a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09d34a2",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardTitle, BCardText, BButton, BCard, BCol} from 'bootstrap-vue'
    installComponents(component, {BCardTitle, BCardText, BButton, BCard, BCol})
    


    import installDirectives from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBPopover} from 'bootstrap-vue'
    installDirectives(component, {'b-popover': VBPopover})
    

export default component.exports